import styles from "./inline-hero-block.module.less";
import type { TLink, THeroTheme, TIndexableBlock, TImage } from "../../../types";
import HeroShapeRenderer from "../../elements/hero-shape-renderer/hero-shape-renderer";
import HeroTextButtonArea from "../../elements/hero-text-button-area/hero-text-button-area";
import { TShapeFillingType, TShapeType } from "../../../types/hero-block-types";

export type TInlineHeroBlockProps = {
  theme?: THeroTheme;
  heading?: string;
  text?: string;
  imageDesktop?: TImage;
  imageMobile?: TImage;
  videoUrlDesktop?: string;
  videoUrlMobile?: string;
  buttonLink?: TLink;
  showShape?: boolean;
  shapeType?: TShapeType;
  shapeFillingType?: TShapeFillingType;
  enableImageOverlay?: boolean;
} & TIndexableBlock;

const InlineHeroBlock = ({
  theme,
  heading,
  text,
  imageDesktop,
  imageMobile,
  videoUrlDesktop,
  videoUrlMobile,
  buttonLink,
  showShape = true,
  shapeType = "shape-1",
  shapeFillingType = "solid-color",
  enableImageOverlay = false,
  index,
}: TInlineHeroBlockProps) => {
  const isFirstBlock = index === 0;

  return (
    <section
      className={[
        styles.wrapper,
        isFirstBlock ? styles.firstBlock : "",
        !showShape ? styles.noShape : "",
        "theme-" + theme,
      ].join(" ")}
    >
      <div className={[styles.innerWrapper, "max-width padded-sides"].join(" ")}>
        <div className={[styles.textWrapper, !showShape ? styles.fullHeightText : ""].join(" ")}>
          <HeroTextButtonArea
            heading={heading}
            text={text}
            visualHeadingType={isFirstBlock ? "h1" : "h2"}
            buttonLink={buttonLink}
            theme={theme ?? undefined}
            index={index}
          />
        </div>
      </div>
      <HeroShapeRenderer
        blockIndex={index}
        shapeFillingType={shapeFillingType}
        showShape={showShape}
        shapeType={shapeType}
        enableImageOverlay={enableImageOverlay}
        imageDesktop={imageDesktop}
        imageMobile={imageMobile}
        videoUrlDesktop={videoUrlDesktop}
        videoUrlMobile={videoUrlMobile}
      />
    </section>
  );
};

export default InlineHeroBlock;
